module.exports = __webpack_public_path__ + "0cfadefb5b06e711797fea5ce1db0995.MP3";